@use "ui/styles/sizes";
@use "ui/styles/fonts";
@use "ui/styles/effects";
@use "ui/styles/colors";

.root {
    display: flex;
    flex-direction: column;
    width: 100%;
    --accordion-trigger-background-color: var(--secondary-background-color);
    --accordion-trigger-hover-background-color: var(--hover-background-color, var(--secondary-background-color));
    --accordion-content-background-color: var(--background-color);
    --accordion-border-color: var(--border-color);
    --accordion-hover-border-color: var(--border-color-hover);

    &.disabled {
        .trigger {
            color: var(--secondary-text-color);
            cursor: not-allowed;

            &:hover {
                background-color: transparent;
            }
        }

        .content {
            color: var(--secondary-text-color);
        }
    }

    &.fullWidth {

        .trigger,
        .content {
            border-left: 0;
            border-right: 0;
        }
    }

    &:not(.fullWidth) {
        .item:first-child {
            .trigger {
                border-top-left-radius: effects.$borderRadiusS;
                border-top-right-radius: effects.$borderRadiusS;
            }
        }

        .item:last-child {

            .content,
            &[data-state="closed"] .trigger {
                border-bottom-left-radius: effects.$borderRadiusS;
                border-bottom-right-radius: effects.$borderRadiusS;
            }
        }
    }
}

.item {
    overflow: hidden;

    &:not(:first-child) {
        .trigger:not(:hover) {
            border-top-color: transparent;
        }
    }

    &[data-state="open"] {
        .trigger .chevron {
            transform: rotate(180deg);
        }
    }

    &[data-disabled] {
        .trigger {
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
}

.header {
    display: flex;
    margin: 0;
}

.trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: sizes.$s4 sizes.$s6;
    font-weight: fonts.$medium;
    line-height: 1;
    background-color: var(--accordion-trigger-background-color);
    border: sizes.$s1 solid var(--accordion-border-color);
    color: var(--text-color);
    cursor: pointer;
    transition: all 200ms ease-in;

    &:hover {
        background-color: var(--accordion-trigger-hover-background-color);
        border-color: var(--accordion-hover-border-color);
    }

    &:focus-visible {
        outline: sizes.$s2 solid var(--accordion-hover-border-color);
        outline-offset: sizes.$s2;
        z-index: 1;
    }
}

.chevron {
    @include effects.iconButton;
    transition: transform 200ms ease-in;
    margin-left: sizes.$s2;
}

.content {
    overflow: hidden;
    color: var(--text-color);
    background-color: var(--accordion-content-background-color);
    border: sizes.$s1 solid var(--accordion-border-color);
    border-top: none;

    &[data-state="open"] {
        animation: slideDown 200ms ease-in-out;
    }

    &[data-state="closed"] {
        animation: slideUp 200ms ease-in-out;
    }
}

.contentText {
    padding: sizes.$s4 sizes.$s6;
}

// Animations for content expand/collapse
@keyframes slideDown {
    from {
        height: 0;
    }

    to {
        height: var(--radix-accordion-content-height);
    }
}

@keyframes slideUp {
    from {
        height: var(--radix-accordion-content-height);
    }

    to {
        height: 0;
    }
}